import moment from 'moment'

export const getIsAtAnniversaryDateRange = (hireDate: Date) => {
  const range = 6
  const DecemberDays = 31

  // 跨年
  if (moment(hireDate).year() !== moment(hireDate).add(range, 'day').year()) {
    const leftDate = DecemberDays - moment(hireDate).date()
    return (
      // 跨年前
      moment().isSameOrAfter(moment(hireDate).year(moment().year()), 'day') ||
      // 跨年后
      moment().isSameOrBefore(moment([moment().year(), 0, range - leftDate]), 'day')
    )
  }

  return moment().isBetween(
    moment(hireDate).year(moment().year()),
    moment(hireDate).year(moment().year()).add(6, 'd'),
    'day',
    '[]'
  )
}
